import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, CircularProgress } from '@mui/material';
import { theme } from './styles/theme';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { RecipeProvider } from './contexts/RecipeContext';
import WelcomeScreen from './components/auth/WelcomeScreen';
import AppShell from './components/common/AppShell';
import HomePage from './components/home/HomePage';
import RecipeListPage from './components/recipes/RecipeListPage';
import RecipeDetailPage from './components/recipes/RecipeDetailPage';
import AddEditRecipePage from './components/recipes/AddEditRecipePage';
import PantryPage from './components/pantry/PantryPage';
import WhatCanICookPage from './components/cook/WhatCanICookPage';
import SettingsPage from './components/settings/SettingsPage';

function ProtectedRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress sx={{ color: 'primary.main' }} />
      </Box>
    );
  }

  if (!user) {
    return <WelcomeScreen />;
  }

  return (
    <RecipeProvider>
      <Routes>
        <Route path="/" element={<AppShell />}>
          <Route index element={<HomePage />} />
          <Route path="recipes" element={<RecipeListPage />} />
          <Route path="recipes/new" element={<AddEditRecipePage />} />
          <Route path="recipes/:id" element={<RecipeDetailPage />} />
          <Route path="recipes/:id/edit" element={<AddEditRecipePage />} />
          <Route path="pantry" element={<PantryPage />} />
          <Route path="cook" element={<WhatCanICookPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </RecipeProvider>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <ProtectedRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
